import { render, staticRenderFns } from "./reactivo_abierto.vue?vue&type=template&id=c132d9dc&"
import script from "./reactivo_abierto.vue?vue&type=script&lang=js&"
export * from "./reactivo_abierto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports